<script>
import AgoraRTC from 'agora-rtc-sdk-ng'
import failStrongIcon from '../assets/failstrong.svg'
import ElSelect from 'element-ui/lib/select'
import 'element-ui/lib/theme-chalk/select.css'
import ElOption from 'element-ui/lib/option'
import 'element-ui/lib/theme-chalk/option.css'

import {
  getDefaultCameraId,
  setDefaultCameraId,
  getCameraErrorText,
  openCameraHelpLink
} from '../helper/deviceDetect.helper'

export default {
  components: {
    ElSelect,
    ElOption
  },
  inject: ['setDetectInfo'],
  data: () => {
    return {
      isDetectFinish: false,
      isFail: false,
      failTip: '',
      localVideoTrack: null,
      failStrongIcon,
      devices: [],
      deviceId: getDefaultCameraId(),
      isOpenedCamera: false
    }
  },
  methods: {
    async openVideo() {
      if (this.localVideoTrack) {
        this.localVideoTrack.close()

        const playerBox = document.getElementById('web-camera-player')
        if (playerBox) {
          playerBox.innerHTML = ''
        }
      }
      await AgoraRTC.createCameraVideoTrack({
        cameraId: this.deviceId,
        encoderConfig: {
          width: 640,
          height: 480,
          bitrate: 500,
          frameRate: { ideal: 15 }
        }
      })
        .then((track) => {
          const playerBox = document.getElementById('web-camera-player')
          if (!playerBox) {
            track.setEnabled(false)
            track.close()
            return
          }

          this.localVideoTrack = track
          this.localVideoTrack.play('web-camera-player')
          this.isOpenedCamera = true
          this.$emit('detect-finsh', true)
          this.setDetectInfo({
            camera: {
              result: '通过',
              isPass: true
            }
          })
        })
        .catch((err) => {
          console.log('err', err.code, err.name, err.message)
          this.$emit('detect-finsh', false)
          const handelErr = (err) => {
            this.isFail = true
            this.failTip = getCameraErrorText(err.code)
            this.$message.error(this.failTip)
            this.setDetectInfo({
              camera: {
                result: this.failTip,
                isPass: false,
                errorCode: err.code
              }
            })
          }
          handelErr(err)
          throw err
        })
        .finally(() => {
          this.isDetectFinish = true
        })
    },
    getDevices() {
      AgoraRTC.getCameras()
        .then((devices) => {
          this.devices = devices
            .filter((device) => device.kind === 'videoinput')
            .map((device) => {
              return {
                label: device.label,
                value: device.deviceId
              }
            })
          // 如果有设备并且没有默认设备id，则设置第一个设备为默认设备id
          if (this.devices.length && !this.deviceId) {
            this.deviceId = this.devices[0].value
            setDefaultCameraId(this.deviceId)
          }

          // 如果有默认设备id 但是设备列表里没有这个设备id，则设置默认设备id为第一个设备id
          if (
            this.deviceId &&
            !devices.find((device) => device.deviceId === this.deviceId)
          ) {
            this.deviceId = this.devices[0].value
            setDefaultCameraId(this.deviceId)
          }
        })
        .catch((err) => {
          this.isFail = true
          this.failTip = getCameraErrorText(err.code)
          this.$message.error(this.failTip)
          this.setDetectInfo({
            camera: {
              result: this.failTip,
              isPass: false,
              errorCode: err.code
            }
          })
          this.$emit('device-error', err.code)
        }).finally(() => {
          this.$emit('device-init-finish')
        })
    },
    openHelpLink(errorCode) {
      openCameraHelpLink(errorCode)
    }
  },
  watch: {
    deviceId() {
      if (this.localVideoTrack) {
        this.openVideo()
      }
      if (this.deviceId) {
        setDefaultCameraId(this.deviceId)
      }
    }
  },
  mounted() {
    this.getDevices()
  },
  destroyed() {
    if (this.localVideoTrack) {
      this.localVideoTrack.close()
      const playerBox = document.getElementById('web-camera-player')
      if (playerBox) {
        playerBox.innerHTML = ''
      }
    }
  }
}
</script>
<template>
  <div class="web-camera-detect-wrapper">
    <div class="guilde-text-wrapper">

      <p v-if="isOpenedCamera && !isFail">请选择能看到人脸的摄像设备，并确保人脸出现在摄像框内</p>

      <p v-if="!isFail && !isOpenedCamera">
        当出现授权弹窗时，请点击“允许”或“Allow”,
        <span @click="openHelpLink('PERMISSION_DENIED')" class="guide-btn">查看指引</span>
      </p>

      <p v-if="isFail">无法访问摄像头，请在系统设置中开启摄像头权限，</p>
      <p v-if="isFail">
        图文操作指引<span
          @click="openHelpLink('NotAllowedError')"
          class="guide-btn"
          >点此查看>></span
        >
      </p>
    </div>
    <div
      class="device-select-box"
      v-if="devices.length"
    >
      <span class="device-select-title">设备：</span>
      <ElSelect
        class="device-select"
        v-model="deviceId"
        placeholder="请选择摄像头"
      >
        <ElOption
          v-for="item in devices"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </ElSelect>
    </div>
    <div class="web-camera-player-wrapper">
      <div id="web-camera-player" class="web-camera-player"
      :style="{
        border: isOpenedCamera ? 'none' : undefined,
        borderColor: isFail ? '#FF5858' : undefined
      }"
      ></div>
      <p v-if="!isDetectFinish && !isFail" class="not-open-tip">未接入摄像头</p>
      <div v-if="isFail" class="fail-tip-box">
        <img
          :src="failStrongIcon"
          style="width: 18px; margin-right: 8px; margin-top: -2px"
          alt="fail"
        />
        <p>{{ failTip }}</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.web-camera-detect-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 132px;

  .web-camera-player-wrapper {
    margin-top: 16px;
    width: 280px;
    height: 160px;
    overflow: hidden;
    position: relative;
    .not-open-tip {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 13.55px;
      line-height: 18.97px;
      letter-spacing: 0px;
      text-align: center;
      color: #00000073;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .fail-tip-box {
      width: 100%;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 13.55px;
      line-height: 13.55px;
      letter-spacing: 0px;
      text-align: center;
      color: #ff5858;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .web-camera-player {
    width: 280px;
    height: 160px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    border: 1px dashed #BFBFBF;
    /deep/ video {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .device-select-box {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: start;
    width: 280px;
    .device-select {
      flex: 1;
    }
    .device-select-title {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      line-height: 19.6px;
      letter-spacing: 0px;
      color: #4a5578;
    }
  }
}
</style>
